// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".view{overflow:hidden}.view .layersButton{position:fixed;bottom:30px;right:20px;box-shadow:0px 3px 6px rgba(0,0,0,.16);background-color:#fff;border-radius:50px;padding:25px 0}.view .addButton{left:20px;right:auto}", ""]);
// Exports
module.exports = exports;
